/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '@app/settings/users/user.model';
import { UsersFormComponent } from '@app/settings/users/users-form/users-form.component';

@Injectable({
  providedIn: 'root',
})
export class UsersFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open form
   * @param user Dialog data
   */
  public open(user: null | User = null) {
    const modal = this.modalService.open(UsersFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.user = user;
    return modal.result;
  }
}
